import styles from "./AuthConfigError.module.css";

export default function AuthConfigError({ errors = [] }) {
  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <h1 className={styles.title}>App Configuration Error</h1>
        <p className={styles.copy}>
          The web app could not start because required local environment variables are missing or
          invalid.
        </p>

        {errors.length ? (
          <ul className={styles.list}>
            {errors.map((error) => (
              <li key={error}>{error}</li>
            ))}
          </ul>
        ) : null}

        <div className={styles.steps}>
          <p>Restore your local `.env` or `.env.development` file, then restart `npm run dev`.</p>
        </div>
      </div>
    </div>
  );
}
